export const getAnnualGrossPremiumEURStringUtils = (annualGrossPremiumEUR, t) => {
    const commaIndex = annualGrossPremiumEUR.indexOf(',');
    const commaDiff = annualGrossPremiumEUR.length - commaIndex - 1;
    const euroPerYear = t('search.results.euroPerYear');
    if (commaIndex > -1) {
        if (commaDiff < 2 && commaDiff >= 0) {
            return `${annualGrossPremiumEUR}${[...Array(2 - commaDiff)]
                .map(() => '0')
                .join('')} ${euroPerYear}`;
        }
        if (annualGrossPremiumEUR.length === commaDiff) {
            return `${annualGrossPremiumEUR},00 ${euroPerYear}`;
        }
    }
    // fallback to just output as legacy sometimes sends '-'
    return `${annualGrossPremiumEUR} ${euroPerYear}`;
};
